import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SafeLiftService } from 'src/app/services/app/safelift.service';
import { App_FormFieldCasesDynamiques } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-cases-dynamiques-preparation',
  templateUrl: './c-cases-dynamiques-preparation.component.html',
  styleUrls: ['./c-cases-dynamiques-preparation.component.scss'],
})
export class CCasesDynamiquesPreparationComponent {
  @Input({ required: true }) field!: App_FormFieldCasesDynamiques;
  @Input({ required: true }) cFormArray!: FormArray<FormGroup<{ label: FormControl<string | null>; value: FormControl<boolean | null>}>>;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) disabledField!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private safeLiftService: SafeLiftService
  ) { }

  onRemoveFormGroupClick(formGroup: FormGroup) {
    if (!this.disabledField) {
      const foundIndexInOriginal = this.cFormArray.controls.findIndex(fg => fg === formGroup);
      if (foundIndexInOriginal !== -1) {
        this.cFormArray.removeAt(foundIndexInOriginal)
      }
    }
  }

  onAddNewFormGroupClick() {
    if (!this.disabledField) {
      this.cFormArray.push(this.safeLiftService.newFormControlForCaseDynPreparation('', false))
    }
  }

}
